import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';

const useInsertMovementOperation = () => {
  const { enqueueSnackbar } = useSnackbar();

  const insertRequest = (
    getMovementOperationList,
    setIsInsertModalOpen,
    setInsertLoading,
    payload,
  ) => {
    axiosClient
      .post(`Operation/Movement/Insert`, {
        zoneGuid: payload.zoneGuid,
        title: payload.title,
        voucherType: payload.voucherType,
        storeID: payload.storeID,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`افزودن با موفقیت انجام شد`, { variant: 'success' });
          getMovementOperationList?.();
          setIsInsertModalOpen?.(false);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setInsertLoading?.(false));
  };

  return { insertRequest };
};

export default useInsertMovementOperation;
